<template>
  <ui-container class="space-y-8 py-8">

    <!-- Header. -->
    <ui-header :title="`Callback #${item.id}`" :subtitle="item.status">
      <template #actions>
        <ui-button-new icon="fas fa-pencil" @click="edit()">Edit</ui-button-new>
        <ui-button-new icon="fas fa-trash" danger @click="openDeleteModal">Delete</ui-button-new>
      </template>
    </ui-header>

    <ui-tabs active="overview" :tabs="tabs" #default="{ isActive }">
        <!-- Overview. -->
      <div v-if="isActive('overview')">
        <ui-data-grid>
          <ui-data-grid-item label="Package">
            <template v-if="item.package_id"><a class="text-brand" :href="item._links.frontend.package">{{ item.package_name }}</a></template>
            <template v-else>{{ item.package_name }}</template>
          </ui-data-grid-item>
          <ui-data-grid-item label="Date" :value="item.date"></ui-data-grid-item>
          <ui-data-grid-item label="Description" :value="item.description" wide></ui-data-grid-item>
          <ui-data-grid-item v-if="item.created_by" label="Created By" :value="item.created_by.name"></ui-data-grid-item>
          <ui-data-grid-item label="Quick action" wide>
            <div class="flex flex-col md:flex-row flex-wrap -m-2">
              <ui-button-new v-if="item.status === 'Open'" class="m-2" icon="fas fa-check-circle" @click="closeCallback">Close</ui-button-new>
              <ui-button-new v-else class="m-2" icon="fas fa-dot-circle" @click="reopenCallback">Open</ui-button-new>
              <a :href="item._links.frontend.download" class="m-2">
                <ui-button-new icon="fas fa-download">Download</ui-button-new>
              </a>
              <ui-button-new class="m-2" icon="fas fa-copy" @click="copyToNcr">Copy To NCR</ui-button-new>
              <ui-button-new v-if="item.package_id" class="m-2" icon="fas fa-copy" @click="copyToDefect">Copy To Defect</ui-button-new>
            </div>
          </ui-data-grid-item>
        </ui-data-grid>
      </div>

      <!-- Files. -->
      <div v-else-if="isActive('files')">
        <filesystem
            compact="true"
            :filesystem-id="item.filesystem_id"
        ></filesystem>
      </div>

      <!-- Files. -->
      <div v-else-if="isActive('notes')">
        <notes :get-url="item._links.frontend.notes" :post-url="item._links.frontend.notes"></notes>
      </div>
    </ui-tabs>
  </ui-container>
</template>

<script>
export default {
  props: {
    item: Object,
    edit: Function,
    removeItem: Function,
  },
  data () {
    return {
      tabs: [
        { value: 'overview', label: 'Overview' },
        { value: 'files', label: 'Files' },
        { value: 'notes', label: 'Notes' },
      ],
    }
  },
  methods: {
    async closeCallback () {
      await this.item.close()

    },
    async reopenCallback () {
      await this.item.reopen()

    },
    async copyToNcr () {
      await this.item.copyToNcr()

    },
    async copyToDefect () {
      await this.item.copyToDefect()

    },
    openDeleteModal () {
      const title = 'Are you sure you want to delete Callback #' + this.item.id + '?'
      const description = 'Deleting this Callback is irreversible. Are you sure you want to delete it?'
      eventBus.$emit('delete-modal-open', title, description, async () => {
        await this.item.delete()
        this.removeItem(this.item)

      });
    },
  },
}
</script>
